/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".box-parent[_ngcontent-%COMP%] {\n  background: #ffffff;\n  padding: 20px 50px 50px 50px;\n  border-radius: 10px;\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2); }\n\n.dropdown-menu[_ngcontent-%COMP%] {\n  width: auto;\n  white-space: nowrap; }\n\n.calendar-trigger[_ngcontent-%COMP%] {\n  border-right: 0;\n  border-top: 0;\n  border-bottom: 0;\n  cursor: pointer;\n  width: 2em;\n  height: 100%;\n  position: absolute;\n  right: 0;\n  top: 0;\n  padding: 0; }\n  .calendar-trigger[_ngcontent-%COMP%]   span[_ngcontent-%COMP%] {\n    top: 50%;\n    left: 50%;\n    margin-top: -.5em;\n    margin-left: -.5em;\n    position: absolute;\n    color: #D5D5D5;\n    font-size: 1.5em; }"];
export { styles as styles };



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-for-it/dashboard-for-it.component.scss.shim.ngstyle.js.pre-build-optimizer.js